import {Inject, injectable} from 'inversify-props';

import {ILoraHardwareService} from '@/services/lora/ILoraHardware.service';
import {IApiService} from '@/services/IApi.service';
import {AntennaType} from '@/model/lora/AntennaType';

@injectable()
export class LoraHardwareService implements ILoraHardwareService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/lora/hardware';

  public async getAvailableRegions(): Promise<string[]> {
    return (await this.apiService.get(`${this.path}/regions`)).map((r: any) => r.id);
  }

  public async getRegion(): Promise<string> {
    return (await this.apiService.get(`${this.path}/region`)).id;
  }

  public async setRegion(region: string): Promise<void> {
    return this.apiService.put(`${this.path}/region`, {
      id: region,
    });
  }

  public async getAntennaType(): Promise<string> {
    return (await this.apiService.get(`${this.path}/antenna-type`)).id;
  }

  public async setAntennaType(antennaType: string): Promise<void> {
    return this.apiService.put(`${this.path}/antenna-type`, {
      id: antennaType,
    });
  }
}
